import { Box } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { CourseInsights } from '../component/templates/CourseInsights'
import { AppBox } from 'src/component/common/analog/molecule/AppBox'
import TeamSelector from '../component/molecules/TeamSelector'
import { useState } from 'react'
import { TeamLearningFilter } from '../component/molecules/TeamLearningFilter'
import dayjs, { Dayjs } from 'dayjs'

export const MyTeamLearningPage = observer(() => {
  const [selectedTeam, setSelectedTeam] = useState<string[]>([])
  const [fromDate, setFromDate] = useState<Dayjs | null>(dayjs().subtract(210, 'day'))
  const [toDate, setToDate] = useState<Dayjs | null>(dayjs())

  return (
    <Box sx={styles.root}>
      <AppBox sx={styles.filter}>
        <TeamSelector
          showOptionForAll
          onChange={setSelectedTeam}
          defaultValues={['select-all']}
          type='team'
        />
        <AppBox sx={{ width: { xs: '100%', md: 'auto' } }}>
          <TeamLearningFilter
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={setFromDate}
            setToDate={setToDate}
          />
        </AppBox>
      </AppBox>
      <CourseInsights fromDate={fromDate} toDate={toDate} selectedTeam={selectedTeam} />
    </Box>
  )
})

const styles = {
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 15,
    padding: 20,
  },
  filter: {
    width: '100%',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 10,
  },
}